//TO MUSI BYĆ ABY BUNDLE ZAWIERAŁ KLASY Z components
//TS nie kompiluje nieużywanych klas??
import "dce-engine";
import "dce-ajax";

import "@app/index";
import "@dce-wire/index";

//import * as DceEngineModule from "dce-engine";
import {DceEngine} from "dce-engine";

//(window as any)["dce-engine"] = DceEngineModule;

DceEngine.start("data-dce", true);
